import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { analyticsService } from 'venn-utils';
import CookiePreferencesModal from './CookiePreferencesModal';
import { COOKIE_SETTINGS } from '../CookiesCommon';
import { cn } from '@/lib/utils';

/* Provides a launch point for the cookie preferences modal for EU users */
const CookiePreferencesTrigger = () => {
  const [cookies] = useCookies([COOKIE_SETTINGS]);
  const [showLink, setShowLink] = useState(false);
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    // If the user has set their cookie settings, insert a link to the modal in the footer
    if (cookies[COOKIE_SETTINGS]) {
      setShowLink(true);
    }
  }, [cookies]);

  useEffect(() => {
    if (showModal) {
      analyticsService.ctaClicked({
        locationOnPage: 'footer',
        purpose: 'Open Cookie Preferences Manager',
        text: 'Cookie Preferences Manager',
        type: 'link',
      });
    }
  }, [showModal]);

  return (
    <>
      {showLink ? (
        <li>
          <button
            type="button"
            onClick={() => setShowModal(true)}
            className={cn(
              'text-venn-primary-main font-bold text-[12px] leading-[16px] text-left border-0',
              'hover:border-b hover:border-solid hover:border-b-venn-primary-main',
              'focus:border-b focus:border-solid focus:border-b-venn-primary-main',
            )}
          >
            Do Not Share My Personal Information
          </button>
        </li>
      ) : null}
      {showModal ? (
        <CookiePreferencesModal
          originalCookiePreferences={parseInt(cookies[COOKIE_SETTINGS], 10)}
          onClose={() => setShowModal(false)}
        />
      ) : null}
    </>
  );
};

export default CookiePreferencesTrigger;
